export default __webpack_public_path__ + "static/media/itsBluzaLogo.045ff3e4.png";